import Translator from "../translates/Translator";

const HeroTitleHexagon = () => {
    const t = Translator();
    // IKA DATA, spol. s r.o. || IKA DATA s.r.o. || IKA DATA
    const companyName = "IKA DATA";

    return (
        <div className="hero-hexagon">
            <span className="hex-text-centering">
                <p className='hero-moto'>{t("ikadata-moto")}</p>
                <p className='hero-name'>{companyName}</p>
                <p className='hero-description'>{t("ikadata-description")}</p>
            </span>
        </div>
    );
}

export default HeroTitleHexagon;